import { render, staticRenderFns } from "./OAClientEditPage.vue?vue&type=template&id=07b470e0"
import script from "./OAClientEditPage.vue?vue&type=script&lang=ts"
export * from "./OAClientEditPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports